import * as styles from "./SectionDogBio.module.scss";

import React from "react";

import { Link } from "gatsby";
export interface DogBioFieldProps {
	icon: React.FC | null;
	title: string;
	value: string | JSX.Element;
	url?: string;
	ExtraField?: () => JSX.Element;
}
export const DogBioField: React.FC<DogBioFieldProps> = ({
	icon,
	title,
	value,
	url,
	ExtraField,
}) => {
	const Icon: React.FC = icon;
	return (
		<div key={title} className={styles.dogbiofieldcontainer}>
			<div className={styles.icon}>{icon && <Icon />}</div>
			<div className={styles.textarea}>
				<div className={styles.title}>{title}</div>
				{url ? (
					<div className={styles.value}>
						<Link to={`${url}&clearPagination=true`}>{value}</Link>
					</div>
				) : (
					<div className={styles.value}>{value}</div>
				)}
			</div>
			{ExtraField && (
				<div className={styles.textarea}>
					<ExtraField />
				</div>
			)}
		</div>
	);
};
